module.exports = __webpack_public_path__ + "static/media/Checkout-2.805ac921.png";